<template>
  <div>
    <v-btn @click="loadLoyalty">
      {{ loyalty.length > 0 ? "Refresh" : "Load" }} loyalty
    </v-btn>
    <v-data-table
      v-if="loyalty.length > 0"
      :headers="headers"
      :items="loyalty"
      :items-per-page="15"
      :expanded.sync="expanded"
      item-key="corporation_id"
      show-expand
      :single-expand="true"
      sort-by="loyalty_points"
      :sort-desc="true"
      :loading="loading"
    >
      <template v-slot:item.name="{ item }">
        <v-tooltip top nudge-top="10" max-width="400">
          <template v-slot:activator="{ on }">
            <span v-on="on">{{ item.name }}</span>
          </template>
          <span>{{ item.description }}</span>
        </v-tooltip>
      </template>
      <template v-slot:item.loyalty_points="{ item }">
        {{ item.loyalty_points | add_commas }}
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <loyalty-store :corp_id="item.corporation_id" />
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState } from "vuex";
import LoyaltyStore from "@/components/LoyaltyStore";

export default {
  name: "CharacterLoyalty",
  components: { LoyaltyStore },
  data() {
    return {
      loading: false,
      expanded: [],
      headers: [
        { text: "Corporation", value: "name" },
        { text: "Loyalty Points", value: "loyalty_points", align: "right" }
      ]
    }
  },
  computed: {
    ...mapState({
      loyalty: state => {
        return state.character_loyalty.map(x => {
          const corp = state.corporations
            .find(y => y.corporation_id == x.corporation_id);
          return { ...x, ...corp }
        });
      }
    })
  },
  methods:{
    loadLoyalty() {
      this.loading = true;
      this.$store.dispatch("loadCharacterLoyalty")
        .then(() => this.loading = false);
    }
  }
}
</script>
